// types
import { Actions } from './email-verification.actions';

// actions
import {
    SET_EMAIL_VERIFICATION,
    RESET_EMAIL_VERIFICATION,
    SET_EMAIL_VERIFICATION_STATUS, EMAIL_VERIFICATION
} from './email-verification.constants';

export interface IState {
    emailVerificationStatus?: EMAIL_VERIFICATION | null;
    emailForVerification?: string;
}

export const initialState: IState = {
    emailVerificationStatus: null,
    emailForVerification: ''
};

export const reducerKey = 'emailVerification' as const;

export const emailVerification = (state = initialState, action: Actions): IState => {
    switch (action.type) {
    case SET_EMAIL_VERIFICATION_STATUS:
        return {
            ...state,
            emailVerificationStatus: action.payload
        };
    case RESET_EMAIL_VERIFICATION:
        return initialState;
    case SET_EMAIL_VERIFICATION:
        return { ...state, emailForVerification: action.payload };
    default:
        return state;
    }
};

export default emailVerification;
